import { useModal } from "@/contexts";
import { createDate, getDefaultParameters } from "@/utils";
import { useNewNavigate } from "@shared/client";
import { API_RESERVE, ReserveBookingResponse } from "@shared/server";
import { useMutation } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useState } from "react";

export const useBookParameter = () => {
    const { onNavigate } = useNewNavigate();
    const { closeModal } = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const mutation = useMutation({
        mutationFn: API_RESERVE.getRoomList<ReserveBookingResponse>,
        onMutate: () => {
            setIsLoading(true);
        },
        onSuccess: (data) => {
            if (data.uid !== "") {
                const { currentObj } = createDate();
                const timeStamp = dayjs(currentObj).valueOf();
                const { idx, co_id } = getDefaultParameters();
                const { uid } = data;

                setIsLoading(false);
                closeModal();
                onNavigate({ path: "/payment", params: { idx, co_id, uid, t: timeStamp } });
            }
        },
    });

    return { mutation, isLoading };
};
